import React, { useEffect, useState } from "react";
import { api, downloadCsv } from "../lib/api";
import { toast } from "sonner";
import { Download, Landmark, Check, Clock } from "lucide-react";

export function Payouts({ pin, refreshKey }) {
  const [winners, setWinners] = useState([]);

  const load = () => api.get("/admin/winners").then((r) => setWinners(r.data)).catch(() => {});
  useEffect(() => { load(); const iv = setInterval(load, 15000); return () => clearInterval(iv); }, [pin, refreshKey]);

  const toggle = async (w) => {
    try {
      await api.post(`/admin/winners/${w.claim_id}/paid`, { pin, paid_out: !w.paid_out });
      setWinners((ws) => ws.map((x) => (x.claim_id === w.claim_id ? { ...x, paid_out: !w.paid_out } : x)));
      toast.success(!w.paid_out ? `${w.display_name} gemarkeerd als uitbetaald` : "Markering verwijderd");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Fout");
    }
  };

  const open = winners.filter((w) => !w.paid_out);
  const fmtIban = (i) => (i ? i.replace(/(.{4})/g, "$1 ").trim() : null);

  return (
    <div className="p-6 rounded-2xl bg-[#12141D] border border-[#00E676]/30" data-testid="payouts-section">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#00E676]">Uitbetalingen</div>
          <h2 className="text-2xl font-bold mt-1" style={{ fontFamily: "Unbounded, sans-serif" }}>
            Winnaars <span className="text-slate-500 text-base font-normal">· <span data-testid="payouts-open-count">{open.length}</span> nog uit te betalen</span>
          </h2>
        </div>
        <button data-testid="export-all-winners" onClick={() => downloadCsv("/admin/winners.csv", "alle-winnaars.csv").catch(() => toast.error("Download mislukt"))}
           className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-[#FFD700]/40 bg-[#FFD700]/10 text-[#FFD700] text-sm font-bold hover:bg-[#FFD700]/20">
          <Download className="w-4 h-4" /> Alle winnaars (CSV)
        </button>
      </div>

      {winners.length === 0 ? (
        <div className="text-sm text-slate-500 mt-4">Nog geen winnaars.</div>
      ) : (
        <div className="mt-4 space-y-2">
          {winners.map((w) => (
            <div key={w.claim_id} data-testid={`payout-${w.claim_id}`}
                 className={`p-3 rounded-xl border flex flex-wrap items-center gap-3 ${w.paid_out ? "bg-[#0B0C10]/60 border-white/5 opacity-70" : "bg-[#0B0C10] border-white/10"}`}>
              <label className="flex items-center gap-2 cursor-pointer select-none">
                <input type="checkbox" data-testid={`paid-checkbox-${w.claim_id}`} checked={w.paid_out} onChange={() => toggle(w)}
                       className="w-5 h-5 accent-[#00E676]" />
                <span className={`text-xs font-bold uppercase ${w.paid_out ? "text-[#00E676]" : "text-[#FFD700]"}`}>
                  {w.paid_out ? <><Check className="inline w-3 h-3" /> Uitbetaald</> : <><Clock className="inline w-3 h-3" /> Open</>}
                </span>
              </label>
              <div className="flex-1 min-w-[160px]">
                <div className="font-bold text-sm">{w.display_name} <span className="text-slate-500 font-normal">· {w.stage_label}</span></div>
                <div className="text-xs text-slate-500">{w.game_title}</div>
              </div>
              <div className="text-lg font-black text-[#00E676]">€{w.prize}</div>
              <div className="w-full sm:w-auto sm:min-w-[260px] text-xs font-mono" data-testid={`payout-iban-${w.claim_id}`}>
                {w.iban ? (
                  <span className="inline-flex items-center gap-1.5 text-slate-200"><Landmark className="w-3 h-3 text-[#00F0FF]" /> {fmtIban(w.iban)} <span className="text-slate-500 font-sans">· {w.account_name}</span></span>
                ) : (
                  <span className="text-[#FF1744]">IBAN nog niet ingevuld door winnaar</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
